/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMultiplier2x = createReactComponent("outline", "multiplier-2x", "IconMultiplier2x", [["path", { "d": "M14 16l4 -4", "key": "svg-0" }], ["path", { "d": "M18 16l-4 -4", "key": "svg-1" }], ["path", { "d": "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0", "key": "svg-2" }]]);

export { IconMultiplier2x as default };
//# sourceMappingURL=IconMultiplier2x.mjs.map
